import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useSiteContent } from "@/contexts/SiteContentContext";
import { HOME } from "@/lib/homeContent";
import { trackEvent } from "@/lib/analytics";
import { usePersonalization } from "@/lib/personalization";

const K = { fontFamily: "Kanit, Arial, sans-serif" };
const S = { fontFamily: "'Noto Serif', Georgia, serif" };

export function useFaqItems() {
  const { section } = useSiteContent();
  const { isRealEstate } = usePersonalization();
  const c = section("faq_spain", HOME.faq);
  const all = Array.isArray(c.items) && c.items.length ? c.items : HOME.faq.items;
  const tagged = all.filter((x) => x.tag === "real_estate");
  const rest = all.filter((x) => x.tag !== "real_estate");
  const items = isRealEstate ? [...tagged, ...rest] : [...rest, ...tagged];
  return { c, items: items.slice(0, 8) };
}

export default function SpainFaq() {
  const { c, items } = useFaqItems();

  return (
    <section id="faq" data-testid="spain-faq" className="bg-white/60 border-t border-[#451C25]/15 py-20 md:py-28 px-6 md:px-10 lg:px-14">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="text-[#897756] text-[11px] tracking-[0.3em] uppercase mb-5 font-semibold" style={K}>{c.eyebrow}</p>
          <h2 data-testid="spain-faq-headline" className="text-3xl md:text-4xl leading-[1.1] tracking-tight" style={{ ...K, fontWeight: 600 }}>{c.headline}</h2>
          <p className="mt-5 text-[#6B4954] text-[15px] md:text-base leading-relaxed" style={S}>{c.sub}</p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-[#451C25]/15" onValueChange={(v) => v && trackEvent("faq_open", { question: v })}>
            {items.map((it, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[#451C25]/15">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left text-lg md:text-xl hover:no-underline hover:text-[#897756] [&>svg]:text-[#897756] [&>svg]:h-5 [&>svg]:w-5" style={{ ...K, fontWeight: 500 }}>
                  {it.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-[15px] md:text-base leading-relaxed text-[#451C25]" style={S}>
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
